import DashboardItem, { proseClasses } from './dashboard-item';
import Card from 'tio-ui/components/card';
import Heading from 'tio-ui/components/heading';
import { LinkTo } from '@ember/routing';
import { getRecommendationCtaRoute } from 'tio-employee/utils/wellness-insights';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import { htmlSafe } from '@ember/template';

/**
 * NB: original ask was for this component to be able to conditionally link
 * directly to a specific quesdtionnaire result view in the case that the
 * component definition arg specifies that this is a transitional component;
 * in that case, something would need to ensure that at least the id of the
 * corresponding recommndation model is available before rendering a non-
 * disabled link, and provide the recommendation id as the link's @model arg,
 * accessible via the WellnessInsightsComponentDefinition model's
 * getRecommendation method called with requestingApp string argument
 *
 * as for where to fetch the recommendations, that could happen in the route
 * model, on the instance method itself, or conditionally in the constructor
 * of this component. none of these ideas sound good to me - james 20250814
 */
export default class Recommendation extends DashboardItem {
  @service declare router: RouterService;

  get recommendationLinkIsRegistered() {
    try {
      return !!this.router.urlFor(getRecommendationCtaRoute(this.args.componentDefinition).to);
    } catch {
      return false;
    }
  }

  get ctaLinkRoute(): string {
    return getRecommendationCtaRoute(this.args.componentDefinition).to;
  }

  get ctaLinkQuery(): Record<string, unknown> {
    return getRecommendationCtaRoute(this.args.componentDefinition).query || {};
  }

  <template>
    <Card @elevation="none">
      <div class="tio-col-extra-loose lg:flex-row lg:items-center lg:justify-between">
        <div class="lg:flex-1">
          <Heading @level={{3}}>{{@componentDefinition.subtitle}}</Heading>
          <div class="mt-2 {{proseClasses}}">
            <p>{{htmlSafe @componentDefinition.text}}</p>
          </div>
        </div>
        <div class="shrink-0">
          {{! One focusable element per action: the button recipe goes ON the link.
              `<Button>` emits this same `.tio-btn` family, but as a native
              <button>, so nesting it in the link would be interactive content
              inside interactive content — two tab stops for one destination. }}
          {{#if this.recommendationLinkIsRegistered}}
            <LinkTo
              @route={{this.ctaLinkRoute}}
              @query={{this.ctaLinkQuery}}
              class="tio-btn tio-btn--primary tio-btn--md w-full text-center"
              data-test-hook="wellness-recommendation__cta--{{@componentDefinition.type}}"
            >
              {{this.translate "recommendation.button_text" (hash type=@componentDefinition.type)}}
            </LinkTo>
          {{else}}
            <a
              href={{this.ctaLinkRoute}}
              class="tio-btn tio-btn--primary tio-btn--md w-full text-center"
              data-test-hook="wellness-recommendation__cta--{{@componentDefinition.type}}"
            >
              {{this.translate "recommendation.button_text" (hash type=@componentDefinition.type)}}
            </a>
          {{/if}}
        </div>
      </div>
    </Card>
  </template>
}
